import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { mergeClasses } from '../../utils/merge-classes';

export interface CollapsibleBoxClasses {
  panel?: string;
  header?: string;
  title?: string;
  chevron?: string;
  body?: string;
}

@Component({
  selector: 'app-collapsible-box',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './collapsible-box.component.html',
  host: {
    class: 'block w-full',
  },
})
export class CollapsibleBoxComponent {
  @Input({ required: true }) title!: string;
  @Input() expanded = true;
  @Input() classes: CollapsibleBoxClasses = {};

  @Output() expandedChange = new EventEmitter<boolean>();

  get panelClasses(): string {
    return mergeClasses(
      'flex flex-col w-full overflow-clip rounded-lg border border-linear-stroke bg-white [--mat-icon-button-icon-color:currentColor] [--mat-icon-color:currentColor]',
      this.classes.panel,
    );
  }

  toggle(): void {
    this.expanded = !this.expanded;
    this.expandedChange.emit(this.expanded);
  }
}
